export const ERROR_MESSAGE = {
  IS_UNDEFINED: (value: string): string => `${value} is undefined.`,
  UNABLE_TO_FIND: (value: string): string => `Unable to find ${value}`,
  SCRIPT_WAS_NOT_LOADED: 'VGS Collect.js script was not loaded.',
  CHANGE_VERSION:
    'Please explicitly set locked VGS Collect.js version before going live. Check out the changelog https://www.verygoodsecurity.com/docs/vgs-collect/js/changelog',
};
